import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="direct-upload"
// Listens to Active Storage direct upload events for progress feedback.
export default class extends Controller {
  static targets = ["input", "lista", "submit"]

  connect() {
    this._pending = 0

    this.element.addEventListener("direct-upload:initialize", this._onInitialize)
    this.element.addEventListener("direct-upload:start", this._onStart)
    this.element.addEventListener("direct-upload:progress", this._onProgress)
    this.element.addEventListener("direct-upload:error", this._onError)
    this.element.addEventListener("direct-upload:end", this._onEnd)
    this.inputTarget.addEventListener("change", this._onFileSelected)

    this._disableSubmit()
  }

  disconnect() {
    this.element.removeEventListener("direct-upload:initialize", this._onInitialize)
    this.element.removeEventListener("direct-upload:start", this._onStart)
    this.element.removeEventListener("direct-upload:progress", this._onProgress)
    this.element.removeEventListener("direct-upload:error", this._onError)
    this.element.removeEventListener("direct-upload:end", this._onEnd)
    this.inputTarget.removeEventListener("change", this._onFileSelected)
  }

  _onFileSelected = () => {
    if (this.inputTarget.files.length > 0) {
      this._enableSubmit()
    } else {
      this._disableSubmit()
    }
  }

  _onInitialize = (event) => {
    const { id, file } = event.detail
    this._pending++

    const li = document.createElement("li")
    li.id = `direct-upload-${id}`
    li.className = "flex justify-between items-center px-4 py-3"
    li.innerHTML = `
      <span class="truncate">${file.name}
        <small class="ml-2 text-gray-400">(${this._formatBytes(file.size)})</small>
      </span>
      <span class="text-sm text-gray-400" data-role="status">Aguardando...</span>
    `
    this.listaTarget.appendChild(li)
  }

  _onStart = (event) => {
    const el = document.getElementById(`direct-upload-${event.detail.id}`)
    if (el) el.querySelector("[data-role=status]").textContent = "Enviando..."
  }

  _onProgress = (event) => {
    const { id, progress } = event.detail
    const el = document.getElementById(`direct-upload-${id}`)
    if (el) el.querySelector("[data-role=status]").textContent = `${Math.round(progress)}%`
  }

  _onError = (event) => {
    const el = document.getElementById(`direct-upload-${event.detail.id}`)
    if (el) {
      el.querySelector("[data-role=status]").innerHTML =
        '<span class="text-red-500">Erro</span>'
    }
    this._pending--
    event.preventDefault()
  }

  _onEnd = (event) => {
    const el = document.getElementById(`direct-upload-${event.detail.id}`)
    if (el) {
      el.querySelector("[data-role=status]").innerHTML =
        '<svg class="size-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>'
    }
    this._pending--
  }

  _disableSubmit() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = true
    this.submitTarget.classList.add("opacity-50", "pointer-events-none")
  }

  _enableSubmit() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = false
    this.submitTarget.classList.remove("opacity-50", "pointer-events-none")
  }

  _formatBytes(bytes) {
    if (bytes === 0) return "0 Bytes"
    const sizes = ["Bytes", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(1)) + " " + sizes[i]
  }
}
